import { AutoAwesome } from "@mui/icons-material";
import { Alert, Button } from "@mui/material";
import { GitPullRequestArrow } from "lucide-react";
import { useParams } from "react-router-dom";
import { ChangeManagementPageLayout } from "src/components/ChangeManagement/ChangeManagementPageLayout";
import { PlanPageTitle } from "src/components/ChangeManagement/PlanPageTitle";
import { PlanRunsTable } from "src/components/ChangeManagement/PlanRunsTable";
import { useOpenChangeManagementAgent } from "src/components/ChangeManagement/useOpenChangeManagementAgent";
import { ChangeManagementPlansSkeleton } from "src/components/Skeletons/ChangeManagementPlansSkeleton";
import { AiGradientButton } from "src/components/ui/AiGradientButton";
import { useGetChangeManagementPlans } from "src/hooks/queries/change-management";

export const ChangeManagementPlansPage = () => {
  const { orgId = "" } = useParams();
  const openAgent = useOpenChangeManagementAgent();
  const {
    data: records,
    isLoading,
    isError,
  } = useGetChangeManagementPlans({
    orgId,
  });

  if (isLoading) return <ChangeManagementPlansSkeleton />;

  return (
    <ChangeManagementPageLayout
      breadcrumbs={[{ label: "Change management" }]}
      rightButtons={
        <AiGradientButton startIcon={<AutoAwesome />} onClick={openAgent}>
          New run
        </AiGradientButton>
      }
    >
      <PlanPageTitle title="Change management">
        Each run reads a change, works out which documents it affects and drafts
        the exact edits for review.
      </PlanPageTitle>
      {isError || !records ? (
        <Alert severity="error">Could not load Change Management plans.</Alert>
      ) : records.length ? (
        <PlanRunsTable orgId={orgId} records={records} />
      ) : (
        <div className="flex flex-col items-center gap-3 rounded border border-solid border-black/[.12] bg-white px-6 py-12 text-center text-black/60">
          <GitPullRequestArrow size={32} className="text-gray-300" />
          <h2 className="m-0 text-[18px] font-semibold leading-[1.5] text-black/[.87]">
            No change plans yet
          </h2>
          <p className="m-0 max-w-[60ch]">
            Start a run and describe the change: a pull request, an issue or a
            PRD. The agent plans the document edits and saves them here.
          </p>
          <Button variant="contained" onClick={openAgent}>
            New run
          </Button>
        </div>
      )}
    </ChangeManagementPageLayout>
  );
};
